import App from './App.vue'
import { router } from '@/routers/common/questions'
import { mountVue } from '@/entries'
mountVue('#app', App, 'questions', router)
